'use client'
import { FC, HTMLAttributes, useEffect, useRef, useState } from 'react'
import { Nav } from './Nav'
import { cn } from '@utils'
import { useMobileNavVisibility } from '@hooks/useMobileNavVisibility.hook'
import { MarketplaceSearchButton } from '@domain/marketplace/components/search/MarketplaceSearchButton'
import { MarketplaceFavoritesButton } from '@domain/marketplace/favorites/MarketplaceFavoritesButton'
import { MarketplaceCartButton } from '@domain/marketplace/cart/MarketplaceCartButton'
import { useMarketplaceCart } from '@domain/marketplace/cart/MarketplaceCartContext'

type MobileFixedNavProps = HTMLAttributes<HTMLDivElement> & {
  isMounted?: boolean
  onSearchClick: () => void
  onFavoritesClick: () => void
  onCartClick: () => void
}

export const MobileFixedNav: FC<MobileFixedNavProps> = ({
  className,
  isMounted,
  onSearchClick,
  onFavoritesClick,
  onCartClick,
}) => {
  const { count } = useMarketplaceCart()
  const prevCountRef = useRef(count)
  const [addSignal, setAddSignal] = useState(0)

  useEffect(() => {
    if (count > prevCountRef.current) {
      setAddSignal((n) => n + 1)
    }
    prevCountRef.current = count
  }, [count])

  const isBottomNavVisible = useMobileNavVisibility(addSignal)

  return (
    <div
      className={cn(
        'fixed bottom-0 left-0 right-0 z-[22] transition-transform duration-300 ease-in-out',
        className,
        {
          'translate-y-0': isBottomNavVisible,
          'translate-y-full': !isBottomNavVisible,
        },
      )}
    >
      <div className="bg-white border-t flex items-center justify-center gap-6 px-6 py-2">
        {isMounted && <MarketplaceSearchButton onClick={onSearchClick} />}
        {isMounted && (
          <MarketplaceFavoritesButton onClick={onFavoritesClick} showBounce />
        )}
        {isMounted && <MarketplaceCartButton onClick={onCartClick} showBounce />}
      </div>
      <div className="bg-cw-purple-light border-t py-2">
        <Nav />
      </div>
    </div>
  )
}
